export default "__VITE_ASSET__C$Kwfj$E__"